import type { Timestamp } from 'firebase/firestore';

export type TokenTransactionType =
  | 'earned'
  | 'earned_bonus'
  | 'spent'
  | 'daily_reset'
  | 'weekly_reset';

// appleUsers/{userId}/profiles/{profileId}/tokenLedger/{entryId}
export interface TokenLedgerEntry {
  type: TokenTransactionType;
  amount: number;
  feature: string;
  description: string;
  balanceAfter: number;
  relatedPlanId: string | null;
  timestamp: Timestamp;
}

// Token costs by tier
export const TOKEN_COSTS = {
  // Tier 1: Basic Help (1–5)
  ENCOURAGEMENT: 1,
  GRAMMAR_CHECK: 2,
  MAGIC_WORDS: 3,

  // Tier 2: AI Coaching (5–15)
  KOKO_HELPER: 5,
  STAGE_FEEDBACK: 8,
  SENTENCE_COACH: 10,

  // Tier 3: Advanced (15–50)
  STORY_SPARKS: 15,
  VISION_BASIC: 10,
  VISION_ADVANCED: 25,

  // Tier 4: Premium (50–100)
  BUSINESS_PLAN_SYNTHESIS: 75,
  STORYTELLER_PRESENTATION: 75,
} as const;

// Token earning amounts
export const TOKEN_EARNINGS = {
  COMPLETE_STAGE: 30,
  COMPLETE_ALL_STAGES: 75,
  COMPLETE_STORY: 40,
  JOURNAL_ENTRY: 20,
  UPLOAD_ARTWORK: 15,
  WEEKLY_3_USES: 50,
  WEEKLY_5_USES_BONUS: 25, // +25 on top of 3-uses (75 total)
} as const;

export const DAILY_TOKEN_ALLOWANCE = 100;
